export type ImpactColumnExperienceType =
  | "Youtube"
  | "Audio"
  | "Video"
  | "Image"
  | "Text"
  | "Location";

export type ImpactColumnExperience = {
  title?: string;
  description?: string;
  url?: string;
  urls?: string[];
  address?: string;
};

export const MAX_COLUMN_IMAGES = 6;

export const IMPACT_COLUMN_EXPERIENCE_TYPES: ImpactColumnExperienceType[] = [
  "Youtube",
  "Audio",
  "Video",
  "Image",
  "Text",
  "Location",
];

export const IMPACT_COLUMN_EXPERIENCE_META: Record<
  ImpactColumnExperienceType,
  { label: string; description: string; icon: string }
> = {
  Youtube: {
    label: "Youtube",
    description: "Link a YouTube video for this section.",
    icon: "youtube",
  },
  Audio: {
    label: "Audio",
    description: "Drop an audio snippet for supporters.",
    icon: "audio",
  },
  Video: {
    label: "Video",
    description: "Upload a video clip with a description.",
    icon: "video",
  },
  Image: {
    label: "Image",
    description: "Share up to 6 images with a short caption.",
    icon: "image",
  },
  Text: {
    label: "Text",
    description: "Write a quick story or message.",
    icon: "doc",
  },
  Location: {
    label: "Location",
    description: "Share a place, address, or map link.",
    icon: "pin",
  },
};

export function emptyColumnExperience(): ImpactColumnExperience {
  return { title: "", description: "", url: "", urls: [], address: "" };
}

export function columnImageUrls(experience?: ImpactColumnExperience): string[] {
  const fromList = (experience?.urls ?? []).map((item) => item.trim()).filter(Boolean);
  const fromUrl = experience?.url?.trim();
  if (fromList.length) {
    return Array.from(new Set(fromList)).slice(0, MAX_COLUMN_IMAGES);
  }
  return fromUrl ? [fromUrl] : [];
}

export function withColumnImages(urls: string[]): Pick<ImpactColumnExperience, "url" | "urls"> {
  const next = Array.from(new Set(urls.map((item) => item.trim()).filter(Boolean))).slice(
    0,
    MAX_COLUMN_IMAGES
  );
  return { urls: next, url: next[0] ?? "" };
}

export function columnExperienceHasContent(
  type: ImpactColumnExperienceType | undefined,
  experience?: ImpactColumnExperience
): boolean {
  if (!type || !experience) return false;
  if (type === "Text") {
    const plain = String(experience.description ?? "")
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
    return Boolean(experience.title?.trim() || plain);
  }
  if (type === "Location") {
    return Boolean(experience.address?.trim() || experience.url?.trim() || experience.title?.trim());
  }
  if (type === "Image") {
    return columnImageUrls(experience).length > 0;
  }
  return Boolean(experience.url?.trim());
}
